import { render, staticRenderFns } from "./UcBillingList.yaml?vue&type=template&id=00d7b660&component"
import script from "./UcBillingList.yaml?vue&type=script&lang=ts&component"
export * from "./UcBillingList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports